module.exports = __webpack_public_path__ + "img/attachment-black-24-dp.aa1e3bdb.svg";